import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Crown, MessageSquare, User, Bike } from 'lucide-react';

interface RoleBadgeProps {
  role: 'ADMIN' | 'AGENT' | 'USER' | 'RIDER' | 'admin' | 'agent' | 'user' | 'rider';
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

const roleConfig = {
  ADMIN: {
    label: 'Admin',
    variant: 'destructive' as const,
    icon: Crown,
    className: 'bg-indigo-100 text-indigo-700 border-indigo-300 hover:bg-indigo-200'
  },
  admin: {
    label: 'Admin',
    variant: 'destructive' as const,
    icon: Crown,
    className: 'bg-indigo-100 text-indigo-700 border-indigo-300 hover:bg-indigo-200'
  },
  AGENT: {
    label: 'Agent',
    variant: 'default' as const,
    icon: MessageSquare,
    className: 'bg-emerald-100 text-emerald-700 border-emerald-300 hover:bg-emerald-200'
  },
  agent: {
    label: 'Agent',
    variant: 'default' as const,
    icon: MessageSquare,
    className: 'bg-emerald-100 text-emerald-700 border-emerald-300 hover:bg-emerald-200'
  },
  USER: {
    label: 'User',
    variant: 'secondary' as const,
    icon: User,
    className: 'bg-rose-100 text-rose-700 border-rose-300 hover:bg-rose-200'
  },
  user: {
    label: 'User',
    variant: 'secondary' as const,
    icon: User,
    className: 'bg-rose-100 text-rose-700 border-rose-300 hover:bg-rose-200'
  },
  RIDER: {
    label: 'Rider',
    variant: 'secondary' as const,
    icon: Bike,
    className: 'bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200'
  },
  rider: {
    label: 'Rider',
    variant: 'secondary' as const,
    icon: Bike,
    className: 'bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200'
  }
};

export const RoleBadge: React.FC<RoleBadgeProps> = ({ 
  role, 
  size = 'md', 
  showIcon = true 
}) => {
  const config = roleConfig[role];
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'text-xs font-medium px-2 py-1',
    md: 'text-sm font-medium px-3 py-1',
    lg: 'text-base font-medium px-4 py-2'
  };

  return (
    <Badge 
      variant={config.variant}
      className={`${config.className} ${sizeClasses[size]} flex items-center gap-1`}
    >
      {showIcon && <Icon className="h-3 w-3" />}
      {config.label}
    </Badge>
  );
};
